export interface IPerfmonFileSubmission {
    id: string;
    site: string;
    performanceMonitoringFileBegins: string;
    settlementPeriods: number[];
    lastSubmitted?: string;
    lastErrorCode: string;
    state: PerfmonFileSubmissionState
}

export enum PerfmonFileSubmissionState {
    Failed = 0,
    PermanentlyFailed = 1,
    Succeeded = 2
}

export interface IPerfmonFilePDF {
    url: string,
    isValid: boolean,
}